import { render } from "./MenuBarClock.vue?vue&type=template&id=7b51aa00"
import script from "./MenuBarClock.vue?vue&type=script&lang=js"
export * from "./MenuBarClock.vue?vue&type=script&lang=js"

import "./MenuBarClock.vue?vue&type=style&index=0&id=7b51aa00&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__